// src/pages/user/UserDashboard.jsx - CORRECTED WITH PROPER USER DATA PERSISTENCE
// DOWNLINE ACTIVATION LOGIC REMOVED COMPLETELY
import React, { useState, useEffect } from 'react';
import logo from '../../assets/logo.jpeg';
import { Link, useLocation, Routes, Route, useNavigate } from 'react-router-dom';
import {
  ChevronDown,
  ChevronUp,
  Home,
  User,
  Wallet,
  ShoppingBag,
  Users,
  DollarSign,
  Headphones,
  LogOut,
  Menu,
  X,
  ClipboardCopy,
  Circle,
  Bell,
  FileText,
  ChevronLeft,
  ChevronRight,
  Shield,
  AlertCircle,
  Lock,
  UserPlus,
  CreditCard,
  History,
  Gift,
  Package,
  TrendingUp,
  Award,
  BarChart3,
  Send,
  Download,
  HelpCircle,
  Settings,
  Zap
} from 'lucide-react';
import { database, ref, get, onValue } from '../../firebase';

// Import all separate page components
import UserDashboardHome from './UserHome';
import Profile from './UserProfile';
import EditProfile from './UserEditProfile';
import Deposit from './UserDeposit';
import AddFund from './UserAddFunds';
import DepositHistory from './UserDepositHistory';
import ActivatePackage from './UserActivatePlan';
import PackageHistory from './UserPackageHistory';
import MyTeam from './UserMyTeam';
import GenealogyTree from './UserNetworkTree';
import AllIncomes from './UserIncomeSummary';
import LevelIncome from './UserLevelIncome';
import ROIIncome from './UserROIIncome';
import ROIWallet from './UserROIWallet';
import RequestWithdrawal from './UserWithdrawalRequest';
import WithdrawalHistory from './UserWithdrawalHistory';
import MyTickets from './UserMyTickets';
import CreateTicket from './UserSupportTicketCreate';
import LevelTree from './UserLevelTree';
import FundHistory from './UserFundHistory';
import LeaderRewards from './UserLeaderRewards';
import TeamSalesRewards from './UserTeamSalesRewards';
import WorkingWallet from './UserWorkingWallet';
import Energywallet from './UserEnergyWallet';
import Transfer from './UserTransfer';
import TransferHistory from './UserTransferHistory';
import AerovoltWallet from './UserMainWallet';
import ScratchCardHistory from './ScratchCardHistory';

const UserDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState('');
  const [userSponsorId, setUserSponsorId] = useState('');
  const [userStatus, setUserStatus] = useState('inactive');
  const [isLoadingStatus, setIsLoadingStatus] = useState(true);
  const [userDbKey, setUserDbKey] = useState('');
  const [userRegistrationDate, setUserRegistrationDate] = useState('');
  const [isAutoLogin, setIsAutoLogin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [mobileBalance, setMobileBalance] = useState('0.00');
  const [userLocation, setUserLocation] = useState(localStorage.getItem('userLocation') || '');

  const buildLocationText = (loc, fallbackCountry) => {
    if (!loc) return fallbackCountry || 'N/A';
    const parts = [loc.city, loc.region, loc.country].filter(Boolean);
    if (parts.length > 0) return parts.join(', ');
    return fallbackCountry || 'N/A';
  };

  // Check for auto-login from admin dashboard
  useEffect(() => {
    const checkAutoLogin = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const isAutoLoginParam = urlParams.get('autoLogin');
        const token = urlParams.get('token');
        const autoLoginUserId = localStorage.getItem('autoLoginUserId');
        const autoLoginToken = localStorage.getItem('autoLoginToken');
        const autoLoginUserData = localStorage.getItem('autoLoginUserData');

        if (isAutoLoginParam && token && autoLoginUserId && autoLoginToken && token === autoLoginToken && autoLoginUserData) {
          setIsAutoLogin(true);
          
          try {
            const userData = JSON.parse(autoLoginUserData);
            
            setUserId(userData.userId || autoLoginUserId);
            setUserName(userData.fullName || localStorage.getItem('autoLoginUserName') || 'User');
            setUserSponsorId(userData.sponsorId || autoLoginUserId);
            
            // CRITICAL FIX: Store ALL user data in localStorage for refresh
            localStorage.setItem('userRole', userData.role || 'user');
            localStorage.setItem('userId', userData.userId || userData.sponsorId || autoLoginUserId);
            localStorage.setItem('userName', userData.fullName || userData.name || autoLoginUserId);
            localStorage.setItem('userEmail', userData.email || '');
            localStorage.setItem('userCountry', userData.country || 'N/A');
            localStorage.setItem('userMobile', userData.mobile || '');
            localStorage.setItem('userSponsorId', userData.sponsorId || userData.userId || autoLoginUserId);
            localStorage.setItem('userBalance', userData.fund?.balance || 0);
            
            // CRITICAL: Store dbKey and registrationDate for refresh
            if (userData.firebaseUserKey || userData.id) {
              localStorage.setItem('dbKey', userData.firebaseUserKey || userData.id || '');
            }
            if (userData.firebaseDateKey || userData.registrationDate) {
              localStorage.setItem('registrationDate', userData.firebaseDateKey || userData.registrationDate || '');
            }
            
            // Also store the user ID in sponsorId format for compatibility
            if (userData.sponsorId) {
              localStorage.setItem('userSponsorId', userData.sponsorId);
            }
            
            setUserRegistrationDate(localStorage.getItem('registrationDate') || userData.registrationDate || '');
            setUserDbKey(localStorage.getItem('dbKey') || userData.firebaseUserKey || userData.id || '');
            
            setMobileBalance(userData.fund?.balance ? parseFloat(userData.fund.balance).toFixed(2) : '0.00');
            
            setUserStatus(userData.status === 'active' ? 'active' : 'inactive');
            
            const cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
            
            if (localStorage.getItem('dbKey') && localStorage.getItem('registrationDate')) {
              await checkPackageActivation(localStorage.getItem('dbKey'), localStorage.getItem('registrationDate'));
            }
            
            setIsChecking(false);
            
          } catch (error) {
            console.error('Error parsing auto-login data:', error);
            checkNormalLogin();
          }
        } else {
          checkNormalLogin();
        }
      } catch (error) {
        console.error('Error in auto-login check:', error);
        checkNormalLogin();
      }
    };

    const checkNormalLogin = async () => {
      try {
        const storedUserId = localStorage.getItem('userId');
        const storedUserName = localStorage.getItem('userName');
        const storedRegistrationDate = localStorage.getItem('registrationDate');
        const storedDbKey = localStorage.getItem('dbKey');
        
        if (!storedUserId || !storedUserName) {
          console.log('No user data in localStorage, redirecting to login');
          navigate('/login');
          return;
        }
        
        console.log('Normal login - localStorage data:', {
          userId: storedUserId,
          userName: storedUserName,
          registrationDate: storedRegistrationDate,
          dbKey: storedDbKey
        });
        
        setUserId(storedUserId);
        setUserName(storedUserName);
        setUserSponsorId(storedUserId);
        setUserRegistrationDate(storedRegistrationDate || '');
        setUserDbKey(storedDbKey || '');
        
        // CRITICAL: If we have dbKey and registrationDate, use them directly
        if (storedDbKey && storedRegistrationDate) {
          console.log('Using stored dbKey and registrationDate');
          setUserDbKey(storedDbKey);
          setUserRegistrationDate(storedRegistrationDate);
          await checkPackageActivation(storedDbKey, storedRegistrationDate);
          setIsChecking(false);
          return;
        }
        
        // Search for user in all date folders only if we don't have dbKey
        console.log('Searching for user in Firebase...');
        const usersRef = ref(database, 'users');
        const snapshot = await get(usersRef);
        
        if (snapshot.exists()) {
          const usersByDate = snapshot.val();
          let userFound = null;
          let dbKey = '';
          let foundRegistrationDate = storedRegistrationDate || '';
          
          // Search through all date folders
          for (const date in usersByDate) {
            const users = usersByDate[date];
            
            if (typeof users === 'object' && users !== null) {
              for (const [key, user] of Object.entries(users)) {
                // Check both userId and sponsorId fields
                if (user.sponsorId === storedUserId || user.userId === storedUserId || key === storedUserId) {
                  userFound = user;
                  dbKey = key;
                  foundRegistrationDate = date;
                  break;
                }
              }
            }
            if (userFound) break;
          }
          
          if (userFound) {
            console.log('User found in Firebase:', {
              date: foundRegistrationDate,
              key: dbKey,
              name: userFound.name
            });
            
            // CRITICAL: Store these values for future refreshes
            localStorage.setItem('dbKey', dbKey);
            localStorage.setItem('registrationDate', foundRegistrationDate);
            localStorage.setItem('userSponsorId', userFound.sponsorId || storedUserId);
            localStorage.setItem('userName', userFound.name || storedUserName);
            
            setUserDbKey(dbKey);
            setUserRegistrationDate(foundRegistrationDate);
            
            // Check for active packages
            const hasActivePackage = await checkActivePackages(userFound.sponsorId || storedUserId);
            
            if (hasActivePackage) {
              setUserStatus('active');
              localStorage.setItem('userStatus', 'active');
            } else {
              setUserStatus(userFound.status === 'active' ? 'active' : 'inactive');
              localStorage.setItem('userStatus', userFound.status === 'active' ? 'active' : 'inactive');
            }
            
            localStorage.setItem('userEmail', userFound.email || '');
            localStorage.setItem('userCountry', userFound.country || '');
            localStorage.setItem('userMobile', userFound.mobile || '');
            localStorage.setItem('userBalance', userFound.fund?.balance || 0);
            
            setMobileBalance(userFound.fund?.balance ? parseFloat(userFound.fund.balance).toFixed(2) : '0.00');
            
            await checkPackageActivation(dbKey, foundRegistrationDate);
            
          } else {
            console.log('User not found in Firebase, clearing localStorage');
            // Clear invalid data
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            localStorage.removeItem('dbKey');
            localStorage.removeItem('registrationDate');
            navigate('/login');
          }
        } else {
          console.log('No users in database');
          navigate('/login');
        }
        
        setIsChecking(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setIsChecking(false);
        // Don't navigate immediately on error, try to use existing data
        if (localStorage.getItem('userId') && localStorage.getItem('userName')) {
          console.log('Using cached user data due to error');
          setIsChecking(false);
        } else {
          navigate('/login');
        }
      }
    };

    checkAutoLogin();
  }, [navigate]);

  // Listen for real-time updates of user data
  useEffect(() => {
    if (!userDbKey || !userRegistrationDate) return;

    const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}`);
    
    const unsubscribe = onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        
        // Update user name if changed
        if (userData.name && userData.name !== userName) {
          setUserName(userData.name);
          localStorage.setItem('userName', userData.name);
        }

        // Update user location (prefer registration location for accuracy)
        const loc = userData.registrationLocation || userData.lastLoginLocation;
        const fallbackCountry = userData.registrationLocation?.country || userData.country;
        const locText = buildLocationText(loc, fallbackCountry);
        if (locText && locText !== userLocation) {
          setUserLocation(locText);
          localStorage.setItem('userLocation', locText);
        }
        
        // Update balance
        if (userData.fund?.balance) {
          setMobileBalance(parseFloat(userData.fund.balance).toFixed(2));
          localStorage.setItem('userBalance', userData.fund.balance);
        }
      }
    });

    return () => unsubscribe();
  }, [userDbKey, userRegistrationDate, userName]);

  const checkPackageActivation = async (dbKey, registrationDate) => {
    try {
      setIsLoadingStatus(true);
      
      const userRef = ref(database, `users/${registrationDate}/${dbKey}`);
      const unsubscribe = onValue(userRef, (snapshot) => {
        if (snapshot.exists()) {
          const userData = snapshot.val();
          
          checkActivePackages(userData.sponsorId || userId).then(hasActivePackage => {
            if (hasActivePackage) {
              setUserStatus('active');
              localStorage.setItem('userStatus', 'active');
            } else {
              setUserStatus(userData.status === 'active' ? 'active' : 'inactive');
              localStorage.setItem('userStatus', userData.status === 'active' ? 'active' : 'inactive');
            }
          });
          
          if (userData.fund?.balance) {
            setMobileBalance(parseFloat(userData.fund.balance).toFixed(2));
            localStorage.setItem('userBalance', userData.fund.balance);
          }
        }
      });

      setIsLoadingStatus(false);
      return unsubscribe;
    } catch (error) {
      console.error('Error checking package activation:', error);
      setUserStatus('inactive');
      localStorage.setItem('userStatus', 'inactive');
      setIsLoadingStatus(false);
    }
  };

  // Separate function to check active packages
  const checkActivePackages = async (userId) => {
    try {
      // First check user's own packages array
      if (userDbKey && userRegistrationDate) {
        const userRef = ref(database, `users/${userRegistrationDate}/${userDbKey}/packages`);
        const snapshot = await get(userRef);
        
        if (snapshot.exists()) {
          const packages = snapshot.val();
          if (Array.isArray(packages)) {
            const hasActive = packages.some(pkg => pkg.status === 'active');
            if (hasActive) return true;
          } else if (typeof packages === 'object') {
            const packagesArray = Object.values(packages);
            const hasActive = packagesArray.some(pkg => pkg && pkg.status === 'active');
            if (hasActive) return true;
          }
        }
      }
      
      // Check package activations in all date folders
      const packageActivationsRef = ref(database, 'PackageActivations');
      const packageSnapshot = await get(packageActivationsRef);
      
      if (packageSnapshot.exists()) {
        const packagesByDate = packageSnapshot.val();
        
        for (const date in packagesByDate) {
          const packages = packagesByDate[date];
          
          if (typeof packages === 'object' && packages !== null) {
            const packageArray = Object.values(packages);
            
            const activePackage = packageArray.find(packageItem => {
              const userIdMatch = (
                packageItem.userId === userId || 
                packageItem.userID === userId ||
                packageItem.user === userId ||
                packageItem.uid === userId ||
                packageItem.sponsorId === userId
              );
              
              const isActive = (
                packageItem.status === 'active' || 
                packageItem.packageStatus === 'active' ||
                packageItem.isActive === true ||
                packageItem.active === true ||
                packageItem.state === 'active'
              );
              
              return userIdMatch && isActive;
            });
            
            if (activePackage) {
              return true;
            }
          }
        }
      }
      
      return false;
    } catch (error) {
      console.error('Error checking active packages:', error);
      return false;
    }
  };

  const toggleDropdown = (label) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  const toggleDesktopSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const handleCopyLink = () => {
 const referralLink = `${window.location.origin}/register?sponsor=${userSponsorId}`; 
    
    navigator.clipboard.writeText(referralLink)
      .then(() => {
        if (window.innerWidth < 768) {
          alert('Referral link copied!');
        } else {
          alert('Referral link copied to clipboard!');
        }
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        alert('Failed to copy link. Please try again.');
      });
  };

  const handleLogout = () => {
    // Clear all user data from localStorage
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userCountry');
    localStorage.removeItem('userMobile');
    localStorage.removeItem('userSponsorId');
    localStorage.removeItem('userBalance');
    localStorage.removeItem('dbKey');
    localStorage.removeItem('registrationDate');
    localStorage.removeItem('userStatus');
    
    // Clear auto-login data
    localStorage.removeItem('autoLoginUserId');
    localStorage.removeItem('autoLoginUserName');
    localStorage.removeItem('autoLoginToken');
    localStorage.removeItem('autoLoginUserData');
    localStorage.removeItem('autoLoginUserRole');
    
    navigate('/login');
  };

  const menuItems = [
    { 
      label: 'Dashboard', 
      path: '/user-dashboard', 
      icon: Home,
      description: 'Overview & Statistics'
    },
    {
      label: 'Funds',
      icon: Wallet,
      description: 'Manage your funds',
      dropdown: [
        { label: 'Add Fund', path: 'addfund', icon: CreditCard, description: 'Deposit money' },
        { label: 'Fund History', path: 'fundhistory', icon: History, description: 'View transactions' },
        { label: 'Scratch History', path: 'scratchhistory', icon: Gift, description: 'Scratch card records' },
      ],
    },
    {
      label: 'Packages',
      icon: Package,
      description: 'Investment plans',
      dropdown: [
        { label: 'Buy Package', path: 'activate', icon: ShoppingBag, description: 'Purchase new package' },
        { label: 'Package History', path: 'packagehistory', icon: History, description: 'Your packages' },
      ],
    },
    {
      label: 'Community',
      icon: Users,
      description: 'Team & Network',
      dropdown: [
        { label: 'My Direct', path: 'network', icon: UserPlus, description: 'Direct referrals' },
        { label: 'Genealogy Tree', path: 'network/tree', icon: BarChart3, description: 'Full team tree' },
        // { label: 'Level Report', path: 'network/level-tree', icon: TrendingUp, description: 'Level wise report' },
      ],
    },
    {
      label: 'Earnings',
      icon: DollarSign,
      description: 'Income details',
      dropdown: [
        { label: 'All Incomes', path: 'incomes', icon: Award, description: 'Total earnings' },
        { label: 'Level Income', path: 'incomes/level', icon: TrendingUp, description: 'Level commission' },
        { label: 'ROI Income', path: 'incomes/roi', icon: DollarSign, description: 'ROI earnings' },
        { label: 'AV Power Wallet', path: 'workingwallet', icon: Wallet, description: 'Power wallet' },
        { label: 'AV Energy Wallet', path: 'energywallet', icon: Zap, description: 'Energy wallet' },
        // { label: 'AV ROI Wallet', path: 'incomes/roiwallet', icon: Wallet, description: 'ROI wallet' },
        { label: 'Aerovolt Wallet', path: 'incomes/Aerovoltwallet', icon: Wallet, description: 'Main wallet' },
      ],
    },
    {
      label: 'Transfer',
      icon: Send,
      description: 'Send funds',
      dropdown: [
        { label: 'Transfer Funds', path: 'transfer', icon: Send, description: 'Transfer to others' },
        { label: 'Transfer History', path: 'transferhistory', icon: History, description: 'Transfer records' },
      ],
    },
    {
      label: 'Withdraw',
      icon: Download,
      description: 'Withdraw earnings',
      dropdown: [
        { label: 'Request Withdrawal', path: 'withdrawal', icon: Download, description: 'Withdraw funds' },
        { label: 'Withdrawal History', path: 'withdrawal/history', icon: History, description: 'Withdrawal records' },
      ],
    },
    {
      label: 'Rewards',
      icon: Award,
      description: 'Special rewards',
      dropdown: [
        // { label: 'Leader Reward', path: 'leaderreward', icon: Award, description: 'Leadership bonus' },
        { label: 'Team Sales Reward', path: 'teamsalesreward', icon: TrendingUp, description: 'Team commission' },
      ],
    },
    {
      label: 'Support',
      icon: Headphones,
      description: 'Get help',
      dropdown: [
        { label: 'My Tickets', path: 'support', icon: HelpCircle, description: 'View tickets' },
        { label: 'Create Ticket', path: 'support/new', icon: Headphones, description: 'New support ticket' },
      ],
    },
    {
      label: 'Profile',
      icon: User,
      description: 'Account settings',
      dropdown: [
        { label: 'My Profile', path: 'profile', icon: User, description: 'View profile' },
        { label: 'Edit Profile', path: 'profile/edit', icon: Settings, description: 'Edit details' },
      ],
    },
  ];

  // Quick action buttons for mobile/desktop
  const quickActions = [
    { label: 'Add Fund', path: 'addfund', icon: CreditCard, color: 'bg-green-600 hover:bg-green-700' },
    { label: 'Buy Package', path: 'activate', icon: ShoppingBag, color: 'bg-blue-600 hover:bg-blue-700' },
    { label: 'Transfer', path: 'transfer', icon: Send, color: 'bg-purple-600 hover:bg-purple-700' },
    { label: 'Withdraw', path: 'withdrawal', icon: Download, color: 'bg-orange-600 hover:bg-orange-700' },
  ];

  if (isChecking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      
      {/* Fixed Top Header - Enhanced with Quick Actions */}
      <header className="fixed top-0 left-0 right-0 bg-card py-2 px-4 md:py-3 md:px-6 flex flex-col shadow-lg z-50 border-b border-border">
        {/* Top Row */}
        <div className="flex items-center justify-between">
          {/* Left Section */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* Mobile Sidebar Toggle Button */}
            <button
              onClick={toggleMobileSidebar}
              className="text-white hover:text-primary/80 transition lg:hidden"
            >
              {isMobileSidebarOpen ? <X size={22} /> : <Menu size={22} />}
            </button>

            <Link to="/user-dashboard" className="flex items-center">
              <div className="relative w-8 h-8 md:w-12 md:h-12 rounded-full overflow-hidden border-2 border-primary/30 group-hover:border-primary transition-colors glow-cyan-sm flex items-center justify-center bg-background">
                <img src={logo} alt="logo" className="w-full h-full object-cover" />
              </div>
            </Link>

            {/* User Info - Mobile */}
            <div className="md:hidden flex flex-col">
              <span className="text-xs font-medium text-white truncate max-w-[100px]">
                {userName || 'User'}
              </span>
              <div className="flex items-center gap-1">
                <Circle 
                  size={6} 
                  fill={userStatus === 'active' ? "#10B981" : "#EF4444"}
                  color={userStatus === 'active' ? "#10B981" : "#EF4444"}
                />
                <span className={`text-xs ${userStatus === 'active' ? 'text-green-400' : 'text-red-400'}`}>
                  {isLoadingStatus ? '...' : userStatus}
                </span>
              </div>
            </div>

            {/* Quick Actions - Desktop */}
            <div className="hidden md:flex items-center gap-2 ml-4">
              {quickActions.map((action) => (
                <button
                  key={action.label}
                  onClick={() => navigate(`/user-dashboard/${action.path}`)}
                  className={`${action.color} text-white px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2 transition transform hover:scale-105`}
                >
                  <action.icon size={16} />
                  <span>{action.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Right Section */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* Balance Display */}
            <div className="hidden md:block bg-primary/10 px-3 py-1.5 rounded-lg border border-primary/20">
              <span className="text-xs text-muted-foreground">Balance:</span>
              <span className="ml-2 font-bold text-primary">₹{mobileBalance}</span>
            </div>

            {/* Copy Referral Link Button - Desktop */}
            <button 
              onClick={handleCopyLink}
              className="hidden md:flex btn-electric text-primary-foreground font-bold px-4 py-2 rounded-full transition transform hover:scale-105 items-center gap-2"
            >
              <ClipboardCopy size={18} />
              <span>Referral Link</span>
            </button>

            {/* User Info - Desktop */}
            <div className="hidden md:block text-foreground font-medium">
              <div className="text-sm">
                Welcome, <span className="text-silver-light">{userName}</span>
              </div>
              <div className="text-xs text-muted-foreground">
                ID: <span className="text-silver-light">{userSponsorId}</span>
              </div>
            </div>

            {/* Logout Button - Desktop */}
            <button
              onClick={handleLogout}
              className="hidden md:flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-secondary text-foreground transition"
            >
              <LogOut size={18} />
              <span className="text-sm">Logout</span>
            </button>

            {/* Mobile Actions */}
            <div className="md:hidden flex items-center gap-2">
              <button
                onClick={handleCopyLink}
                className="p-2 rounded-lg bg-primary/20 text-white hover:bg-primary/30 transition"
                title="Copy Referral Link"
              >
                <ClipboardCopy size={16} />
              </button>
              <button
                onClick={handleLogout}
                className="p-2 text-white hover:text-red-400 transition"
              >
                <LogOut size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Quick Actions Row */}
        <div className="md:hidden flex items-center justify-around mt-2 pt-2 border-t border-border">
          {quickActions.map((action) => (
            <button
              key={action.label}
              onClick={() => navigate(`/user-dashboard/${action.path}`)}
              className="flex flex-col items-center gap-1"
            >
              <div className={`${action.color} p-2 rounded-full`}>
                <action.icon size={16} />
              </div>
              <span className="text-xs text-white">{action.label}</span>
            </button>
          ))}
        </div>
      </header>

      {/* Main Layout */}
      <div className="flex flex-1 pt-20 md:pt-16">
        {/* Sidebar - Enhanced with Descriptions */}
        <aside
          className={`
            fixed top-20 md:top-16 left-0 h-[calc(100vh-5rem)] md:h-[calc(100vh-4rem)]
            bg-gray-900
            border-r border-gray-700
            flex flex-col
            z-40
            transition-all duration-300 ease-in-out
            ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            ${isSidebarOpen ? 'w-72' : 'w-20'}
            lg:translate-x-0 lg:bg-sidebar-background lg:border-border
            overflow-hidden
          `}
        >
          {/* Collapse Button (Desktop) */}
          <div className="hidden lg:flex items-center justify-end p-3">
            <button
              onClick={toggleDesktopSidebar}
              className="text-white hover:text-primary/80 transition lg:text-primary p-1 rounded-full hover:bg-primary/10"
            >
              {isSidebarOpen ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
            </button>
          </div>

          {/* Balance Card in Sidebar */}
          {isSidebarOpen && (
            <div className="px-3 mb-4">
              <div className="bg-gradient-to-r from-primary/20 to-primary/5 p-3 rounded-xl border border-primary/30">
                <div className="text-xs text-muted-foreground mb-1">Your Balance</div>
                <div className="text-xl font-bold text-primary">₹{mobileBalance}</div>
                <div className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                  <Circle size={6} fill={userStatus === 'active' ? "#10B981" : "#EF4444"} color={userStatus === 'active' ? "#10B981" : "#EF4444"} />
                  Status: <span className={userStatus === 'active' ? "text-green-400" : "text-red-400"}>{userStatus}</span>
                </div>
              </div>
            </div>
          )}

          {/* Scrollable Menu */}
          <nav className="flex-1 overflow-y-auto scrollbar-hide px-2 pb-4">
            {menuItems.map((item) => (
              <div key={item.label} className="mb-1">
                {item.dropdown ? (
                  <div>
                    <button
                      onClick={() => toggleDropdown(item.label)}
                      className={`
                        w-full flex items-center justify-between
                        px-3 py-2.5 rounded-xl transition-all text-sm
                        ${openDropdown === item.label
                          ? 'bg-primary/20 text-white shadow-lg border border-primary/30'
                          : 'hover:bg-gray-800 text-white hover:text-white'}
                      `}
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <item.icon size={18} className="flex-shrink-0" />
                        {isSidebarOpen && (
                          <div className="flex flex-col items-start">
                            <span className="font-medium">{item.label}</span>
                            {item.description && (
                              <span className="text-xs text-muted-foreground">{item.description}</span>
                            )}
                          </div>
                        )}
                      </div>
                      {isSidebarOpen && (
                        <div className="flex-shrink-0">
                          {openDropdown === item.label ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                        </div>
                      )}
                    </button>

                    {/* Dropdown */}
                    {openDropdown === item.label && isSidebarOpen && (
                      <div className="mt-1 ml-8 space-y-0.5">
                        {item.dropdown.map((sub) => (
                          <Link
                            key={sub.path}
                            to={`/user-dashboard/${sub.path}`}
                            className={`
                              flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all
                              ${location.pathname.startsWith(`/user-dashboard/${sub.path}`)
                                ? 'bg-primary/10 text-white border-l-2 border-primary'
                                : 'hover:bg-gray-800 text-white'}
                            `}
                            onClick={() => isMobileSidebarOpen && setIsMobileSidebarOpen(false)}
                          >
                            {sub.icon && <sub.icon size={16} className="text-muted-foreground" />}
                            <div className="flex flex-col">
                              <span>{sub.label}</span>
                              {sub.description && (
                                <span className="text-xs text-muted-foreground">{sub.description}</span>
                              )}
                            </div>
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    className={`
                      flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-sm
                      ${location.pathname === item.path
                        ? 'bg-primary/20 text-white shadow-lg border border-primary/30'
                        : 'hover:bg-gray-800 text-white hover:text-white'}
                    `}
                    onClick={() => isMobileSidebarOpen && setIsMobileSidebarOpen(false)}
                  >
                    <item.icon size={18} />
                    {isSidebarOpen && (
                      <div className="flex flex-col">
                        <span className="font-medium">{item.label}</span>
                        {item.description && (
                          <span className="text-xs text-muted-foreground">{item.description}</span>
                        )}
                      </div>
                    )}
                  </Link>
                )}
              </div>
            ))}

            {/* Terms & Policies in Sidebar */}
            {isSidebarOpen && (
              <div className="mt-6 pt-6 border-t border-gray-700">
                <div className="space-y-2">
                  <Link
                    to="/terms"
                    target="_blank"
                    className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-gray-800 text-white transition text-sm"
                  >
                    <FileText size={16} />
                    <span>Terms & Conditions</span>
                  </Link>
                  <Link
                    to="/privacy"
                    target="_blank"
                    className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-gray-800 text-white transition text-sm"
                  >
                    <Shield size={16} />
                    <span>Privacy Policy</span>
                  </Link>
                </div>
              </div>
            )}
          </nav>
        </aside>

        {/* Mobile Overlay */}
        {isMobileSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/60 z-30 lg:hidden"
            onClick={toggleMobileSidebar}
          />
        )}

        {/* Main Content */}
        <main className={`
          flex-1
          bg-gradient-to-b from-background to-card
          overflow-y-auto
          transition-all duration-300
          ${isSidebarOpen ? 'lg:ml-72' : 'lg:ml-20'}
        `}>
          <div className="p-3 md:p-4 lg:p-6">
            <div className="max-w-7xl mx-auto">
              <Routes>
                <Route index element={<UserDashboardHome />} />
                <Route path="profile" element={<Profile />} />
                <Route path="profile/edit" element={<EditProfile />} />
                <Route path="deposit" element={<Deposit />} />
                <Route path="addfund" element={<AddFund />} />
                <Route path="fundhistory" element={<FundHistory />} />
                <Route path="scratchhistory" element={<ScratchCardHistory />} />
                <Route path="packagehistory" element={<PackageHistory />} />
                <Route path="deposithistory" element={<DepositHistory />} />
                <Route path="activate" element={<ActivatePackage />} />
                <Route path="network" element={<MyTeam />} />
                <Route path="network/tree" element={<GenealogyTree />} />
                <Route path="network/level-tree" element={<LevelTree />} />
                <Route path="incomes" element={<AllIncomes />} />
                <Route path="incomes/level" element={<LevelIncome />} />
                <Route path="incomes/roi" element={<ROIIncome />} />
                <Route path="incomes/roiwallet" element={<ROIWallet />} />
                <Route path="withdrawal" element={<RequestWithdrawal />} />
                <Route path="withdrawal/history" element={<WithdrawalHistory />} />
                <Route path="support" element={<MyTickets />} />
                <Route path="support/new" element={<CreateTicket />} />
                <Route path="leaderreward" element={<LeaderRewards />} />
                <Route path="workingwallet" element={<WorkingWallet />} />
                <Route path="energywallet" element={<Energywallet />} />
                <Route path="teamsalesreward" element={<TeamSalesRewards />} />
                <Route path="transfer" element={<Transfer />} />
                <Route path="transferhistory" element={<TransferHistory />} />
                <Route path="incomes/Aerovoltwallet" element={<AerovoltWallet />} />
              </Routes>
            </div>
          </div>
        </main>
      </div>

      {/* Hide Scrollbar */}
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default UserDashboard;